import { fetchHierarchyAccessRequestsListApi } from 'api/accessRequests/fetchers/fetchHierarchyAccessRequestsListApi'
import { createUseFetch } from 'api/common/createUseFetch'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useFetchHierarchyRequestsListApi = createUseFetch({
  queryKey: ApiQueryKeys.HIERARCHY_REQUESTS,
  fetcher: fetchHierarchyAccessRequestsListApi,
})
